import { useQuery } from "@tanstack/react-query";
import { fetchOneSchemaToken } from "@/api/oneschema";

export function useOneSchemaToken(enabled: boolean) {
  return useQuery({
    queryKey: ["oneschema-token"],
    queryFn: fetchOneSchemaToken,
    enabled,
    staleTime: Number.POSITIVE_INFINITY,
  });
}
